import { createAsyncThunk } from '@reduxjs/toolkit';

import { getEntitlements, reportFeatureUsage } from '~/services';

import {
  entitlementsConsumeQuota,
  entitlementsFailure,
  entitlementsRequest,
  entitlementsSetResolution,
} from './slices';

export const fetchEntitlements = createAsyncThunk(
  'entitlements/fetch',
  async (_, { dispatch }) => {
    dispatch(entitlementsRequest());
    try {
      const res = await getEntitlements();
      if (res.status === 200 && res.data) {
        dispatch(entitlementsSetResolution(res.data));
        return res.data;
      }
      dispatch(entitlementsFailure('Não foi possível carregar suas permissões.'));
      return null;
    } catch (err) {
      const message =
        err instanceof Error ? err.message : 'Erro ao carregar permissões.';
      dispatch(entitlementsFailure(message));
      return null;
    }
  },
);

export const consumeFeatureUsage = createAsyncThunk(
  'entitlements/consume',
  async (slug: string, { dispatch }) => {
    try {
      const res = await reportFeatureUsage(slug);
      if (res.status >= 200 && res.status < 300) {
        if (res.data) {
          dispatch(
            entitlementsConsumeQuota({
              feature: slug,
              used: res.data.used,
              remaining: res.data.remaining,
            }),
          );
        }
        return res.data ?? {};
      }
      return null;
    } catch {
      return null;
    }
  },
);
